const DEFAULT_ERROR_MESSAGE = '요청 처리 중 오류가 발생했습니다.';

// 운영에서는 같은 출처(gworks.co.kr / www.gworks.co.kr 모두)로 호출해 CSP·CORS 문제를 피한다
export const API_BASE_URL = process.env.NODE_ENV === 'production' ? '' : 'https://www.gworks.co.kr';

export function apiUrl(path: string): string {
  return path.startsWith('/') ? `${API_BASE_URL}${path}` : path;
}

export class ApiError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

export async function apiRequest<T>(input: RequestInfo, init?: RequestInit): Promise<T> {
  const resolvedInput = typeof input === 'string' ? apiUrl(input) : input;
  const response = await fetch(resolvedInput, init);
  const contentType = response.headers.get('content-type') ?? '';
  const body = contentType.includes('application/json') ? await response.json() : null;

  if (!response.ok) {
    throw new ApiError(body?.message ?? DEFAULT_ERROR_MESSAGE, response.status);
  }

  return body as T;
}
